const STORAGE_KEY = "portal_auth_sessions";

export function loadPortalSessions() {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error("Failed to load portal sessions from localStorage", error);
    return {};
  }
}

export function savePortalSessions(sessions) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(sessions));
  } catch (error) {
    console.error("Failed to save portal sessions to localStorage", error);
  }
}

export function upsertPortalSession(subdomain, session) {
  const sessions = loadPortalSessions();
  const next = {
    isAuthenticated: session.isAuthenticated,
    accessToken: session.accessToken,
    portalSlug: session.portalSlug,
  };
  if (session.portalId !== undefined) {
    next.portalId = session.portalId;
  } else if (sessions[subdomain]?.portalId !== undefined) {
    next.portalId = sessions[subdomain].portalId;
  }
  sessions[subdomain] = next;
  savePortalSessions(sessions);
}

export function removePortalSession(subdomain) {
  const sessions = loadPortalSessions();
  delete sessions[subdomain];
  savePortalSessions(sessions);
}

export function clearAllPortalSessions() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error("Failed to clear portal sessions from localStorage", error);
  }
}

export function decodeJwtPayload(token) {
  if (!token) return null;
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Failed to decode JWT payload", error);
    return null;
  }
}

export function isAccessTokenExpired(token, skewSeconds = 30) {
  const payload = decodeJwtPayload(token);
  if (!payload || !payload.exp) {
    return true;
  }
  const now = Math.floor(Date.now() / 1000);
  // Proactively expire 30s before actual exp to prevent sending stale tokens.
  // Using + so we trigger refresh BEFORE the backend rejects the token.
  return payload.exp < now + skewSeconds;
}

export function getPortalSlugFromToken(token) {
  const payload = decodeJwtPayload(token);
  return payload?.portal_slug || null;
}
